import dayjs from "dayjs";
import React, {Component} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import {removeNullFields} from "../../../../common/mapper";
import {PaymentStatus} from "../../common/constants";
import Filter from "../common/filter";
import TabBBMBelumLengkap from "./tabBBMBelumLengkap";
import TabBBMBelumRealisasi from "./tabBBMBelumRealisasi";
import TabBBMRealisasi from "./tabBBMRealisasi";
import moment from "moment";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";

class TabBBM extends Component {
  constructor(props) {
    super(props);
    this.initialSearchData = {
      tanggalAwal: dayjs(new Date()).format("DD-MM-YYYY"),
      tanggalAkhir: dayjs(new Date()).format("DD-MM-YYYY"),
    };
    this.initialPagination = {
      totalData: 1,
      page: 1,
      limit: 5,
    };
    this.state = {
      tabIndex: 0,
      loading: false,
      filterVisible: false,
      filterData: {},
      searchData: this.initialSearchData,
      submittedFilterData: {},
      skipNextPaginationFetch: false,
      dataTable: [],
      pagination: this.initialPagination,
    };
  }

  componentDidMount() {
    this.fetchData({
      tanggalBBM: this.initialSearchData,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.tabIndex !== this.state.tabIndex) {
      this.refetch({
        tanggalBBM: this.initialSearchData,
      });
    }
    const { submittedFilterData, pagination, skipNextPaginationFetch } =
      this.state;
    if (
      (prevState.pagination.page !== pagination.page ||
        prevState.pagination.limit !== pagination.limit) &&
      !this.state.skipNextPaginationFetch
    ) {
      this.fetchData(submittedFilterData, pagination.page, pagination.limit);
    }
    if (skipNextPaginationFetch) {
      this.setState({ skipNextPaginationFetch: false });
    }

    if (prevProps.kodeCabang?.value !== this.props.kodeCabang?.value) {
      this.handleResetPeriode();
      this.handleResetPagination();
      this.fetchData({
        ...submittedFilterData,
        tanggalBBM: this.initialSearchData,
      });
    }
  }

  fetchData = async (filter = {}, page = 1, limit = 5) => {
    console.log("FILTER", filter);
    this.setState((prevValue) => ({
      ...prevValue,
      submittedFilterData: filter,
      loading: true,
    }));

    const payload = {
      kodeCabang: this.props.kodeCabang?.value || "",
      paymentStatus: PaymentStatus.BELUM_LENGKAP,
      ...filter,
      operator: filter?.operator ? filter.operator.value : null,
      jenisRelasi: filter?.jenisRelasi ? filter.jenisRelasi.value : null,
      jenisDokumen: filter?.jenisDokumen ? filter.jenisDokumen.value : null,
      bankId: filter?.bankId ? filter.bankId.value : null,
      tanggalBBM: filter?.tanggalBBM,
    };
    
    if(this.state.tabIndex === 2){
      payload.tanggalRealisasiPayment = filter?.tanggalBBM;
      delete payload.tanggalBBM;
    }

    const response = await Api.create("NAGAMAS_TRANSACTION").getBBMData({
      paramFilters: removeNullFields(payload),
      limit,
      page,
    });
    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
      const total = response.data.data.reduce(
        (sum, item) => sum + (item.paymentAmount || 0),
        0
      );
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: response.data.data,
        totalPayment: total,
        loading: false,
        pagination: {
          ...prevValue.pagination,
          totalData: response.data.totalData,
        },
      }));
    } else {
      this.props.setError({
        menuName: "Transaksi Bank BBM",
        errorMessage: response.data.message,
      });
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: [],
        loading: false,
        pagination: {
          ...prevValue.pagination,
          totalData: 0,
        },
      }));
    }
  };

  handleTabChange = (index) => {
    this.setState((prevValue) => ({
      ...prevValue,
      tabIndex: index,
      filterData: {},
      searchData: this.initialSearchData,
      pagination: this.initialPagination, 
    }));
  };

  handlePeriodChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      searchData: {
        ...prevValue.searchData,
        [name]: moment(value).format("DD-MM-YYYY"),
      },
    }));
  };

  handleSubmitPeriod = () => {
    this.setState({ skipNextPaginationFetch: true });
    this.handleResetPagination();
    const paymentDate = removeNullFields(this.state.searchData);
    this.refetch({ tanggalBBM: paymentDate });
  };

  handleSubmitFilter = async () => {
    this.handleResetPagination();
    this.handleResetPeriode();
    const tanggalDocRef1 = removeNullFields(
      this.getPeriodInput(this.state.filterData?.tanggalDokumenRef1)
    );
    const tanggalDocRef2 = removeNullFields(
      this.getPeriodInput(this.state.filterData?.tanggalDokumenRef2)
    );
    const count = parseInt(this.state.filterData?.count, 10);
    await this.refetch(
      removeNullFields({
        ...this.state.filterData,
        tanggalDokumenRef1: tanggalDocRef1,
        tanggalDokumenRef2: tanggalDocRef2,
        ...(isNaN(count) ? {} : { count: count }),
      })
    );
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: false,
       searchData: {
        tanggalAwal: null,
        tanggalAkhir: null,
      },
    }));
  };

  handleClearFilter = () => {
    this.setState((prevValue) => ({ ...prevValue, filterData: {} }));
  };

  handleFilterValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleFilterDateChange = (key, name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [key]: {
          ...prevValue.filterData[key],
          [name]: value,
        },
      },
    }));
  };

  handleFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  refetch = async (filter = {}) => {
    const { page, limit } = this.state.pagination;

    const paymentStatus =
      this.state.tabIndex === 0
        ? PaymentStatus.BELUM_LENGKAP
        : this.state.tabIndex === 1
        ? PaymentStatus.BELUM_REALISASI
        : PaymentStatus.REALISASI;

    const finalFilter = { ...filter, paymentStatus };

    await this.fetchData(finalFilter, page, limit);

    this.setState((prevValue) => ({
      ...prevValue,
      submittedFilterData: finalFilter,
    }));
  };


  getPeriodInput = (data) => ({
    tanggalAwal: data?.tanggalAwal
      ? dayjs(data.tanggalAwal).format("DD-MM-YYYY")
      : null,
    tanggalAkhir: data?.tanggalAkhir
      ? dayjs(data.tanggalAkhir).format("DD-MM-YYYY")
      : null,
  });

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  handleResetPeriode = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      searchData: this.initialSearchData,
    }));
  };

  handleResetPagination = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: this.initialPagination,
      skipNextPaginationFetch: true,
    }));
  };

  // handleRefresh = () => {
  //   this.handleResetPagination();
  //   this.handleResetPeriode();
  //   this.refetch({ tanggalBBM: this.initialSearchData });
  // };

  handleRefresh = () => {
    const { page, limit } = this.state.pagination;
    const { submittedFilterData } = this.state;

    this.fetchData(submittedFilterData, page, limit);
  };


  render() {
    return (
      <div>
        <Tabs
          selectedIndex={this.state.tabIndex}
          onSelect={this.handleTabChange}
        >
          <TabList>
            <Tab>BELUM LENGKAP</Tab>
            <Tab>BELUM REALISASI</Tab>
            <Tab>REALISASI</Tab>
          </TabList>
          <TabPanel>
            <TabBBMBelumLengkap
              {...this.props}
              submittedFilter={this.state.submittedFilterData}
              state={this.state}
              onRefresh={this.handleRefresh}
              onPeriodChange={this.handlePeriodChange}
              onSubmitPeriod={this.handleSubmitPeriod}
              onShowFilter={this.handleFilterVisibility}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleRowsPerPage}
            />
          </TabPanel>
          <TabPanel>
            <TabBBMBelumRealisasi
              {...this.props}
              submittedFilter={this.state.submittedFilterData}
              state={this.state}
              onRefresh={this.handleRefresh}
              onPeriodChange={this.handlePeriodChange}
              onSubmitPeriod={this.handleSubmitPeriod}
              onShowFilter={this.handleFilterVisibility}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleRowsPerPage}
            />
          </TabPanel>
          <TabPanel>
            <TabBBMRealisasi
              {...this.props}
              submittedFilter={this.state.submittedFilterData}
              state={this.state}
              onRefresh={this.handleRefresh}
              onPeriodChange={this.handlePeriodChange}
              onSubmitPeriod={this.handleSubmitPeriod}
              onShowFilter={this.handleFilterVisibility}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleRowsPerPage}
            />
          </TabPanel>
        </Tabs>
        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
        {this.state.filterVisible && (
          <Filter
            {...this.props}
            tab="BBM"
            kodeCabang={this.props.kodeCabang?.value}
            data={this.state.filterData}
            visible={this.state.filterVisible}
            onClickClose={this.handleFilterVisibility}
            onValueChange={this.handleFilterValueChange}
            onDateChange={this.handleFilterDateChange}
            onSubmit={this.handleSubmitFilter}
            onClear={this.handleClearFilter}
          />
        )}
      </div>
    );
  }
}

export default TabBBM;
